import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type CreatePredictionFeedback = ClientInferResponseBody<
  typeof contract.feedback.createPredictionFeedback
>;

export type CreatePredictionFeedbackDto = ClientInferRequest<
  typeof contract.feedback.createPredictionFeedback
>["body"];

export const createPredictionFeedback = async ({
  predictionId,
  payload,
}: {
  predictionId: string | undefined;
  payload: CreatePredictionFeedbackDto;
}): Promise<CreatePredictionFeedback> => {
  if (!predictionId) {
    throw new Error("Prediction ID is required");
  }

  const response = await api.feedback.createPredictionFeedback.mutation({
    params: {
      predictionId,
    },
    body: payload,
  });

  if (response.status === 201) {
    return response.body;
  }

  throw new ApiError("Failed to create PredictionFeedback", response.status, response.body);
};
